import React, { CSSProperties } from 'react';
import { Images } from 'src/Tenants';
import './Loader.scss';

interface LoaderProps {
  center?: boolean;
  style?: React.CSSProperties;
  position?: boolean;
  imageHeight?: string | number;
  imageWidth?: string | number;
  containerHeight?: string | number; // New prop for total container height
}

const Loader = ({
  center = false,
  style = {},
  position = false,
  imageHeight = '100px',
  imageWidth = '100px',
  containerHeight,
}: LoaderProps) => {
  const loaderImage = Images?.loader;

  const imageStyle = {
    width: imageWidth,
    height: imageHeight,
    ...(position ? { position: 'fixed' as const } : {}),
  };

  // Calculate padding if containerHeight is specified
  const containerStyle: CSSProperties = containerHeight
    ? {
        height: containerHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }
    : style;

  if (center) {
    return (
      <div
        style={{
          position: 'absolute',
          display: 'flex',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 3,
          ...containerStyle,
        }}
      >
        <img style={imageStyle} src={loaderImage} alt="Loading..." />
      </div>
    );
  }

  return (
    <div className="loader" style={containerStyle}>
      <img style={imageStyle} src={loaderImage} alt="Loading..." />
    </div>
  );
};

export default Loader;
